import { createBrowserRouter, Navigate } from "react-router-dom";
import { hasTokens } from "@crm/utils";

// Layouts
import { AppLayout } from "./components/layout/AppLayout";
import { AuthLayout } from "./components/layout/AuthLayout";

// Pages
import { LoginPage } from "./features/auth/pages/LoginPage";
import { MyIncidentsPage } from "./features/incidents/pages/MyIncidentsPage";
import { IncidentDetailPage } from "./features/incidents/pages/IncidentDetailPage";

/** Protected route wrapper */
function ProtectedRoute({ children }: { children: React.ReactNode }) {
  if (!hasTokens()) {
    return <Navigate to="/login" replace />;
  }
  return <>{children}</>;
}

/** Public route wrapper (redirect if authenticated) */
function PublicRoute({ children }: { children: React.ReactNode }) {
  if (hasTokens()) {
    return <Navigate to="/" replace />;
  }
  return <>{children}</>;
}

export const router = createBrowserRouter([
  // Auth routes
  {
    element: <AuthLayout />,
    children: [
      {
        path: "/login",
        element: (
          <PublicRoute>
            <LoginPage />
          </PublicRoute>
        ),
      },
    ],
  },
  // App routes (protected)
  {
    element: (
      <ProtectedRoute>
        <AppLayout />
      </ProtectedRoute>
    ),
    children: [
      {
        path: "/",
        element: <MyIncidentsPage />,
      },
      {
        path: "/incidents/:id",
        element: <IncidentDetailPage />,
      },
    ],
  },
  // Fallback
  {
    path: "*",
    element: <Navigate to="/" replace />,
  },
]);
